import Toastify, { CloseButton } from "./Toastify";

export { Toastify, CloseButton };
export default Toastify;
